import { ShipmentType } from '../enums/_index';
import { ShipmentSummary } from '../shipments/shipment-summary';

export class ContainerSummary extends ShipmentSummary { 
    
    constructor() {
        super(ShipmentType.Container);   
    }

}
